<template>
  <v-row>
    <v-col class="py-0">
      <v-expansion-panel-content>
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.background"
              label="Цвет фона"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.toolbar"
              label="Цвет тулбара"
            />
          </v-col>
        </v-row>

        <!-- Logo staff -->
        <v-row>
          <v-col
            cols="12"
            class="deep-purple--text text--lighten-1"
          >
            Текст над лого Оплатой картой сотрудника
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoStaff.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textAboveLogoStaff.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textAboveLogoStaff.text"
              label="Текст над лого Оплатой картой сотрудника"
              type="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <uploadFiles
              v-model="screen.logoStaffFile"
              label="Логотип для вида оплаты картой сотрудника"
              :btn_text="'Загрузить фотографию'"
              :limit="1"
              :single="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoStaffData.width"
              label="Ширина изображения"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="screen.logoStaffData.height"
              label="Высота изображения"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            class="cyan--text text--lighten-1"
          >
            Текст под лого Оплатой картой сотрудника
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoStaff.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.textBelowLogoStaff.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              v-model="screen.textBelowLogoStaff.text"
              label="Текст под лого Оплатой картой сотрудника"
              type="text"
            />
          </v-col>
        </v-row>
        <!-- end Logo stuff -->

        <v-row>
          <v-col cols="12">
            <v-checkbox
              v-model="screen.showButton"
              label="Показывать кнопку Отмена на экране"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <strong>Кнопка отмены</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.button1.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button1.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button1.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button1.background"
              label="Цвет фона"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <strong>Кнопка оплаты</strong>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              v-model="screen.button2.radius"
              label="Размер радиуса"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button2.text.size"
              label="Размер шрифта"
              type="number"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="screen.button2.text.color"
              label="Цвет шрифта"
            />
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="screen.button2.background"
              label="Цвет фона"
            />
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-col>
  </v-row>
</template>
<script>

import { fifthScreen } from "@/views/loyalty/models/justpay-configuration-interface.model"

export default {
  name: 'SetupStaffPaymentScreen',
  model: {
    prop: "screen",
    event: "changeScreen",
  },
  props: {
    confType: {
      type: Number,
      default: 0
    },
    screen: {
      default: () => (fifthScreen)
    },
  },
  watch: {
    screen () {
      this.$emit('changeScreen', this.screen)
    }
  },
}
</script>

<style scoped>

</style>
